"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableFooter_1 = __importDefault(require("@material-ui/core/TableFooter"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const Text_1 = __importDefault(require("../../../Text"));
function TableFooter(_a) {
    var { errorText, loading = false, styles, colSpan, pageLength = 0 } = _a, props = __rest(_a, ["errorText", "loading", "styles", "colSpan", "pageLength"]);
    if (pageLength === 0) {
        return (react_1.default.createElement(TableFooter_1.default, { "data-testid": props['data-testid'] },
            react_1.default.createElement(TableRow_1.default, null,
                react_1.default.createElement(TableCell_1.default, { className: styles.footerCell, colSpan: colSpan }, !loading ? (react_1.default.createElement(react_1.default.Fragment, null, errorText ? (react_1.default.createElement(Text_1.default, { variant: "span", color: "error" }, errorText)) : (react_1.default.createElement(Text_1.default, null, "No records found")))) : (react_1.default.createElement("div", { className: styles.cellAlign },
                    react_1.default.createElement(CircularProgress_1.default, { color: "secondary", size: 16, variant: "indeterminate" }),
                    react_1.default.createElement("span", { className: styles.leftSpace }, "Loading...")))))));
    }
    return null;
}
exports.default = TableFooter;
//# sourceMappingURL=index.js.map